import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SessionStatus } from '../constants';

const statusToIcon = status => {
  switch (status) {
    case SessionStatus.COMPLETED:
      return 'fa fa-check-circle-o text-success';
    case SessionStatus.PENDING:
      return 'fa fa-hourglass-o text-warning';
    case SessionStatus.FAILED:
      return 'fa fa-times-circle-o text-danger';
    case SessionStatus.MANUAL_CONTROL:
      return 'fa fa-flag-o text-warning';
    case SessionStatus.ERROR:
      return 'fa fa-exclamation-circle text-danger';
    default:
      return '';
  }
};

export const SessionStatusIcon = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <i className={statusToIcon(status)} aria-hidden="true" style={{ marginRight: '4px' }} />
      {t(`enums.sessionStatus.values.${status}`, status)}
    </div>
  );
};

SessionStatusIcon.propTypes = {
  status: PropTypes.oneOf(Object.keys(SessionStatus)),
};
